import { useEffect, useCallback } from 'react';
import notificationService from "../../../services/notification-service";
import ShowNotification from "../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../utils/configuration";

export const useCuisineOrderNotifications = (
    getListCuisineOrderManagement,
    page,
    rowsPerPage,
    orderBy,
    order,
    receiptTimeOrder,
    searchData,
    deviceId
) => {
    const refreshList = useCallback(() => {
        const sortExpression = orderBy + ' ' + order + ((orderBy && orderBy !== "receiptTime") ? receiptTimeOrder : '');
        getListCuisineOrderManagement(page + 1, rowsPerPage, sortExpression, searchData);
    }, [getListCuisineOrderManagement, page, rowsPerPage, order, orderBy, receiptTimeOrder, searchData]);

    const handleCuisineOrderGenericNotification = useCallback((data) => {
        console.log('Received generic cuisine order notification:', data);
        refreshList();
    }, [refreshList]);

    const handleCuisineOrderCreated = useCallback((data) => {
        if (!data || data.deviceId === deviceId) return;
        ShowNotification('Có đơn đăng ký suất ăn mới được tạo!', NotificationMessageType.Success);
        refreshList();
    }, [refreshList, deviceId]);

    const handleCuisineOrderUpdated = useCallback((data) => {
        if (!data || data.deviceId === deviceId) return;
        ShowNotification('Có đơn đăng ký suất ăn vừa được cập nhật!', NotificationMessageType.Success);
        refreshList();
    }, [refreshList, deviceId]);

    const handleCuisineOrderDeleted = useCallback((data) => {
        if (!data || data.deviceId === deviceId) return;
        ShowNotification('Có đơn đăng ký suất ăn vừa bị xóa!', NotificationMessageType.Success);
        refreshList();
    }, [refreshList, deviceId]);

    useEffect(() => {
        let isComponentMounted = true;

        const initNotificationServices = async () => {
            try {
                await notificationService.initialize();
                if (isComponentMounted) {
                    notificationService.addNotificationListener('CuisineOrderCreated', handleCuisineOrderCreated);
                    notificationService.addNotificationListener('CuisineOrderUpdated', handleCuisineOrderUpdated);
                    notificationService.addNotificationListener('CuisineOrderDeleted', handleCuisineOrderDeleted);
                    notificationService.addNotificationListener('cuisine_order', handleCuisineOrderGenericNotification);
                }
            } catch (error) {
                console.error('Error initializing notification services:', error);
            }
        };

        initNotificationServices();

        return () => {
            isComponentMounted = false;
            try {
                notificationService.removeNotificationListener('CuisineOrderCreated', handleCuisineOrderCreated);
                notificationService.removeNotificationListener('CuisineOrderUpdated', handleCuisineOrderUpdated);
                notificationService.removeNotificationListener('CuisineOrderDeleted', handleCuisineOrderDeleted);
                notificationService.removeNotificationListener('cuisine_order', handleCuisineOrderGenericNotification);
            } catch (error) {
                console.error('Error removing notification listeners:', error);
            }
        };
    }, [handleCuisineOrderCreated, handleCuisineOrderUpdated, handleCuisineOrderDeleted, handleCuisineOrderGenericNotification]);
};
